import React from "react";
import {Select, Spin} from "antd";
import {BillToList} from "../models/billto";

const Option = Select.Option;

export class SelectBillTo extends React.Component {
  state = {
    data: [],
    value: [],
    fetching: false,
    search: '',
  };

  fetchBillTo =(value = '') => {
    this.setState({fetching: true, search: value});
    BillToList({'search': value})
      .then(response => {
        this.setState({data: response.data.results, fetching: false});
      });
  };

  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
   this.props.onChange(value? value.key: null);
  };

  render() {
    const {fetching, data, value} = this.state;
    return (
      <div>
          <div className="pos-relative">
            <Select allowClear={true} labelInValue onChange={this.handleChange} onSearch={this.fetchBillTo} onFocus={this.fetchBillTo} showSearch value={value} placeholder="Select Bill To"
              notFoundContent={fetching ? <Spin size="small" /> : "Not Found"} filterOption={false}
              style={{ width: "100%" }}>
               {data.map(d => (
                  <Option key={d.id}>{d.account_number} | {d.company_name}</Option>
                ))}
            </Select>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/data_selectors/SelectBillTo.jsx